import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CreateForm from 'components/event/CreateForm';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import StyledModalBody from 'components/modal/StyledModalBody';

import { getAllTags } from 'actions/Tag';

import { cancelCreatingEvent, createEvent } from 'actions/Event';

import { getTeamMembers, createTeamLabel } from 'actions/Team';

import { Modal } from 'reactstrap';

const CreateEventModal = ({
  modalOpen,
  cancelCreatingEvent,
  createEvent,
  createTeamLabel,
  event,
  team,
  tags,
  user,
  getAllTags,
  getTeamMembers,
  teamMembers,
  teamTemplates,
  globalTemplates,
}) => {
  useEffect(() => {
    getAllTags();
  }, [getAllTags, tags.length]);

  useEffect(() => {
    if (!event) return;

    getTeamMembers(event.team._id);
  }, [event, getTeamMembers]);

  /**
   * Shouldn't show the form if there is no event object (has the teamId)
   * Shouldn't show the for if there are no team members (there should always be 1+ team members)
   */
  const readyToShowForm = event && teamMembers && teamMembers.length;
  const teamId = readyToShowForm ? event.team._id : null;

  return (
    <Modal isOpen={modalOpen && readyToShowForm} toggle={cancelCreatingEvent}>
      <StyledModalHeader toggle={cancelCreatingEvent}>
        Create an event
      </StyledModalHeader>
      <StyledModalBody>
        {readyToShowForm && (
          <CreateForm
            owners={teamMembers}
            team={team}
            event={event}
            labels={team.labels}
            templates={teamTemplates}
            globalTemplates={globalTemplates}
            user={user}
            onSubmit={(formData, photoFile, labels, templates) => {
              createEvent(
                event.team._id,
                formData,
                photoFile,
                labels,
                templates,
              );
            }}
            onLabelCreated={createTeamLabel.bind(null, teamId)}
            onCancel={cancelCreatingEvent}
          />
        )}
      </StyledModalBody>
    </Modal>
  );
};

export default connect(
  (state) => {
    const {
      creatingEvent,
      selectedTeamMembers,
      team,
      teamTemplates,
      globalShowTemplates,
      tags,
      user,
    } = state;

    return {
      tags,
      team,
      modalOpen: creatingEvent ? true : false,
      event: creatingEvent,
      teamMembers: selectedTeamMembers,
      teamTemplates,
      globalTemplates: globalShowTemplates,
      user,
    };
  },
  {
    createEvent,
    createTeamLabel,
    cancelCreatingEvent,
    getTeamMembers,
    getAllTags,
  },
)(CreateEventModal);
